module.exports = __webpack_public_path__ + "img/real-sociedad.92f3ef35.png";